(function ($) {
	class Search {

		$search = null
		$form = null
		$search_input = null

		autocomplete_delay = 250 // ms

		request = null
		request_timeout = null

		constructor() {
			$(document).gp_ready(this.init_forms)
		}

		init_forms = () => {
			// Init elements
			this.$search = $('.search')
			this.$form = this.$search.find('form')
			this.$search_input = this.$form.find('input[name="search"]')
			this.$autocomplete = this.$search.find('.search-autocomplete')

			// Bind actions
			this.$search_input.gp_on('focus', this.open_outocomplete)
			this.$search_input.gp_on('keyup', this.do_autocomplete)

			// Bind search close
			$(document).gp_on('keyup', this.keyup_close)
			$(document).gp_on('click', this.click_close)

			// Bind modal input focus
			$(document).gp_on('modal_opened', this.modal_opened)

		}

		open_outocomplete = () => {
			this.$search.addClass('-focus')
		}

		close_outocomplete = () => {
			this.$search_input.blur() // unfocus input
			this.$search.removeClass('-focus')
		}

		do_autocomplete = (e) => {

			let search_term = $(e.target).val()

			// Show loading
			this.show_loading()

			// Abort previous request if is loading
			if (this.request) {
				this.request.abort()
			}

			// Wait to prevent request spam
			clearTimeout(this.load_timeout)
			this.load_timeout = setTimeout(() => {

				// Send request
				this.request = gp_ajax({
					url: ghostpress_params.ajax_url,
					type: "post",
					dataType: 'json',
					data: {
						action: 'search_autocomplete',
						search_term: search_term
					},
				})

			}, search_term ? this.autocomplete_delay : 0) // show empty state immediately
		}

		show_loading() {
			// Use template
			let loading_template = this.$search.find('template.search__loading')[0]
			this.$autocomplete.html($(loading_template.content.cloneNode(true)).children())
		}

		keyup_close = (e) => {
			if (e.key === "Escape") {
				this.close_outocomplete()
			}
		}

		click_close = (e) => {
			if (!this.$search.has(e.target).length) {
				this.close_outocomplete()
			}
		}

		modal_opened = (e, id, context, $modal) => {
			if (id == 'search') {
				setTimeout(() => {
					$modal.find('input').focus()
				}, 300)
			}
		}
	}

	new Search()

})(jQuery)

